module.exports = __webpack_public_path__ + "static/media/masthead-bunbury-herald.b3452928.svg";